export enum TUTORIAL_VIEW {
  LESSONS = 'lessons',
  PLAYER = 'player',
  COMPLETION = 'completion'
}

export enum TUTORIAL_ACTION {
  ENROL = 'enrol',
  LEAVE_A_RATING = 'leave_a_rating',
  WATCH_AGAIN = 'watch_again',
  CONTINUE = 'continue',
  START = 'start'
}

export enum TUTORIAL_STATUS {
  NOT_STARTED = 'not_started',
  COMPLETED = 'completed',
  IN_PROGRESS = 'in_progress'
}